import { type ExportLabels, useExportLabels } from '~/hooks/useExportTerminologyEnabled';

export interface DataUseAcknowledgementProps {
  /** Overrides the flag-resolved copy. */
  labels?: ExportLabels;
}

/** The confidentiality and 811 safe-digging notice a user acknowledges before data leaves CivilGrid. */
export function DataUseAcknowledgement({ labels: labelsOverride }: DataUseAcknowledgementProps = {}) {
  const flagLabels = useExportLabels();
  const labels = labelsOverride ?? flagLabels;

  return (
    <div className="flex flex-col space-y-2">
      <div>{labels.confirmModalBody}</div>
      <div>
        Use of CivilGrid services does not preclude you from{' '}
        <span className="font-bold">calling locate and mark services (811)</span>, and employing other proper safe
        digging practices prior to initiating construction.
      </div>
      <div className="font-bold">We expect you to follow all safe digging legal requirements and best practices.</div>
    </div>
  );
}
